var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/shared/stylesheets/switcher.scss';
import { forwardRef, useImperativeHandle, useRef } from 'react';
export const Switcher = forwardRef((_a, ref) => {
    var { checked = false, disabled = false, onClick } = _a, otherProps = __rest(_a, ["checked", "disabled", "onClick"]);
    const checkboxRef = useRef(null);
    useImperativeHandle(ref, () => ({
        processClick: () => {
            var _a;
            (_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    }));
    const handleChange = () => {
        if (disabled) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const classNames = ['switcher', checked ? 'checked' : '', disabled ? 'disabled' : ''];
    const className = classNames.filter(Boolean).join(' ');
    return (_jsxs("label", { className: className, children: [_jsx("input", Object.assign({ ref: checkboxRef, type: "checkbox", checked: checked, disabled: disabled, onChange: handleChange, className: "switcher-input", role: "switch" }, otherProps)), _jsx("div", { className: "switcher-stroke" }), _jsx("div", { className: "switcher-thumb" })] }));
});
